import React, { FC, ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { TextField } from '@mui/material';

type FreeTextFilterComponentProps = {
    freeTextFilterChange: (freeTextInput: string) => void;
    label: string;
    fullWidth?: boolean;
    value: string;
};

// TODO: Not sure we need this component, could just use the TextField right away
const FreeTextFilterComponent: FC<FreeTextFilterComponentProps> = ({
    freeTextFilterChange,
    label,
    fullWidth = true,
    value,
}: FreeTextFilterComponentProps) => {
    const { t: translate } = useTranslation(['users']);
    const handleFilterChange = (event: ChangeEvent<HTMLInputElement>) => {
        freeTextFilterChange(event.target.value);
    };
    const translatebleLabel = label.toUpperCase().split(' ').join('_');
    return (
        <TextField
            fullWidth={fullWidth}
            id="filter-name"
            margin="dense"
            label={translate(translatebleLabel)}
            value={value}
            onChange={handleFilterChange}
        />
    );
};

export default FreeTextFilterComponent;
